import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../../auth.service';

/** canMatch, so a customer account never downloads the conversion chunk. Each tool re-checks
 *  its own capability; this only keeps the screen to staff. */
export const internalGuard: CanMatchFn = () =>
  inject(AuthService).isInternal() ? true : inject(Router).createUrlTree(['']);
